import { Typography } from "antd";

const SectionHeading = ({
    style,
    level,
    heading
}) => {

    return(
        <div className="heading-container">
            <div className="line-heading"></div>
            <div>
                <Typography.Title level={level ? level : 4}>{heading}</Typography.Title>
            </div>
      </div>
    )

}
export default SectionHeading;